import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { AddNewServiceForBusinessComponent } from "../new-v2-component/add-new-service-for-business/add-new-service-for-business.component";
import { AddNewTemplateServiceForBusinessComponent } from "../new-v2-component/add-new-template-service-for-business/add-new-template-service-for-business.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { UntypedFormControl } from "@angular/forms";
import { YoutubeEmbedVideoComponent } from "../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { SelectBusinessCountryComponent } from "src/app/shared/components/select-business-country/select-business-country.component";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
import { DialogService } from "src/app/providers/dialog.service";

@Component({
  selector: "sm-new-services",
  templateUrl: "./new-services.component.html",
  styleUrls: ["./new-services.component.scss"],
})
export class NewServicesComponent implements OnInit,OnDestroy {
  
  apisub: Subscription
  searchString: UntypedFormControl = new UntypedFormControl('');
  businessListData:any = []
  loader: boolean = false
  public page: number = 1;
  serviceList: any[] = [];
  datalength!: number
  isEmployeeAndHasBusinessButDoesNotHaveAccess:boolean = false
  constructor(
    private navservice: NavigationService, 
    private router: Router,
    private _modelRef: MatDialog,
    private loaderservice: LoaderServiceService,
    private apiservice: ApiService,
    private dialog:MatDialog,
    private dialogService:DialogService
  ) {
    this.navservice.hideSidebarAndNav = false;

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_BASIC_ENTITY_LIST){

          this.businessListData = []
          if(resdata.result){
            this.businessListData = resdata.result
          //     this.businessListData.forEach((element: any) => {
          //   // Parse if string
          //   element.employee_functionality_list =
          //     typeof element.employee_functionality_list === "string"
          //       ? JSON.parse(element.employee_functionality_list)
          //       : element.employee_functionality_list;

          //   const list = element.employee_functionality_list || [];

          //   // Set defaults
          //   element.member_access = 0;
          //   element.customer_access = 0;
          //   element.service_access = 0;
          //   element.bookings_access = 0;

          //   if (Array.isArray(list)) {
          //     list.forEach((fn: any) => {
          //       const access = fn?.access_status === 1 ? 1 : 0;
          //       const name = fn?.functionality_name || "";

          //       switch (name) {
          //         case "Members":
          //           element.member_access = access;
          //           break;

          //         case "Customers":
          //           element.customer_access = access;
          //           break;

          //         case "Services & charges":
          //           element.service_access = access;
          //           break;

          //         case "Booking history":
          //           element.bookings_access = access;
          //           break;
          //       }
          //     });
          //   }
          // });

            let checkForAccessLength = this.businessListData.length
            this.businessListData = this.businessListData
            .map((element: any) => ({
              ...element, // Spread existing properties
              isSelected: 0 // Add the isSelected property
            }))
            .filter((element: any) => 
              (element.is_owner == 1 )|| (
                element.entitySubscriptionInfo && 
                element.entitySubscriptionInfo !== 'null' &&
                element.employeeSubscriptionInfo &&
                element.employeeSubscriptionInfo !== 'null' && element.employee_status == 1)
            );
            if(checkForAccessLength - this.businessListData.length > 0){
              this.isEmployeeAndHasBusinessButDoesNotHaveAccess = true
            }  
            if(this.businessListData.length > 0){
            this.businessListData[0].isSelected = 1
            this.selectedBusiness = this.businessListData[0]
            localStorage.setItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,this.selectedBusiness.entity_public_hash_id)
            sessionStorage.setItem('shop_service_status', this.selectedBusiness.shop_service_status)
            sessionStorage.setItem('home_service_status',this.selectedBusiness.home_service_status)
            sessionStorage.setItem('virtual_service_status',this.selectedBusiness.virtual_service_status)

            let isEntityForeign = this.selectedBusiness.currency == 'INR' ? '0' : '1'

            localStorage.setItem(SM_CONSTANTS.IS_ENTITY_FOREIGN, isEntityForeign)
            }
            
            }
            if(this.businessListData.length > 0){

              this.apiservice.getServices(this.selectedBusiness.hashId, '0', this.page.toString())
            }
            else{
              this.loaderservice.showLoader = false
              this.loader = false

            }
      }
      if(resdata.responseType === SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT){
        const getServiceType = (homeStatus:number, shopStatus:number, for_virtual:number) => {
          const combination = (homeStatus << 2) | (shopStatus << 1) | for_virtual;
        
          switch (combination) {
            case 0b000:
              return 'None';  // No services available
            case 0b001:
              return 'Virtual';
            case 0b010:
              return 'Shop';
            case 0b011:
              return 'Shop + Virtual';
            case 0b100:
              return 'Home';
            case 0b101:
              return 'Home + Virtual';
            case 0b110:
              return 'Shop + Home';
            case 0b111:
              return 'Shop + Home + Virtual';
            default:
              return 'Unknown';
          }
        };
        this.serviceList = [];
        this.datalength = 0
        if(resdata.result){
          
          this.datalength = resdata.result ? resdata.result[0].totalCount : 0
          this.serviceList = [];
          resdata.result.forEach((element: any) => {
           
              this.serviceList.push(element);
         
          });
          this.serviceList.forEach(element => {
            if(element.homeStatus != 1){
              element.home_rate = '-'
            }
            if(element.shopStatus != 1){
              element.shop_rate = '-'
            }
            if(element.for_virtual != 1){
              element.virtual_rate = '-'
            }
            if(element.shopDiscountedPrice == null || element.shopDiscountedPrice == 0){
              element.shopDiscountedPrice = '-'
            }
            if(element.homeDiscountedPrice == null || element.homeDiscountedPrice == 0){
              element.homeDiscountedPrice = '-'
            }
            if(element.virtual_discounted_amount == null || element.virtual_discounted_amount == 0){
              element.virtual_discounted_amount = '-'
            }

            element.service_type = getServiceType(element.homeStatus, element.shopStatus, element.for_virtual);

            // if(element.homeStatus == 0 && element.shopStatus == 1){
            //   element.service_type = 'Shop'
            // }
            // if(element.homeStatus == 1 && element.shopStatus == 0){
            //   element.service_type = 'Home'
            // }
            // if(element.homeStatus == 1 && element.shopStatus == 1){
            //   element.service_type = 'Shop + Home'
            // }
            // if(element.homeStatus == 1 && element.shopStatus == 1 && element.for_virtual == 1){
            //   element.service_type = 'Shop + Home + Virtual'
            // }

          })
          console.log( this.serviceList);
          // this.serviceList.forEach((item )=> {
          //   item.addressInfo = JSON.parse(item.addressInfo).address_line
          // })
              console.log( this.serviceList);
        }
        this.loaderservice.showLoader = false
        this.loader = false
        this.hideDiv = false
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_SERVICE_DATA_BY_KEYWORD){
        const getServiceType = (homeStatus:number, shopStatus:number, for_virtual:number) => {
          const combination = (homeStatus << 2) | (shopStatus << 1) | for_virtual;
        
          switch (combination) {
            case 0b000:
              return 'None';  // No services available
            case 0b001:
              return 'Virtual';
            case 0b010:
              return 'Shop';
            case 0b011:
              return 'Shop + Virtual';
            case 0b100:
              return 'Home';
            case 0b101:
              return 'Home + Virtual';
            case 0b110:
              return 'Shop + Home';
            case 0b111:
              return 'Shop + Home + Virtual';
            default:
              return 'Unknown';
          }
        };
        this.serviceList = [];
        this.datalength = 0
          console.log(resdata);
          if(resdata.result){
            this.datalength = resdata.result ? resdata.result[0].totalCount : 0
          
            resdata.result.forEach((element: any) => {
             
                this.serviceList.push(element);
           
            });
            this.serviceList.forEach(element => {
              if(element.homeStatus != 1){
                element.home_rate = '-'
              }
              if(element.shopStatus != 1){
                element.shop_rate = '-'
              }
              if(element.for_virtual != 1){
                element.virtual_rate = '-'
              }
              if(element.shopDiscountedPrice == null || element.shopDiscountedPrice == 0){
                element.shopDiscountedPrice = '-'
              }
              if(element.homeDiscountedPrice == null || element.homeDiscountedPrice == 0){
                element.homeDiscountedPrice = '-'
              }
              if(element.virtual_discounted_amount == null || element.virtual_discounted_amount == 0){
                element.virtual_discounted_amount = '-'
              }
  
              element.service_type = getServiceType(element.homeStatus, element.shopStatus, element.for_virtual);
            })
  
           
          }
         
          
        }
      if(resdata.responseType === SM_CONSTANTS.ADD_UPDATE_SERVICE_TYPE_RESULT){
        if (resdata.result) {
          if (resdata.result.errorcode == 2) {
            this.loaderservice.showLoader = false;
            const dialogRef = this._modelRef.open(
              CustomConfirmDialogComponent,
              {
                width: "400px",
                data: {
                  title: "Alert",
                  message:
                    "This service could not be deleted as it is linked with active or ex-members in your business. Please unlink the service from the member and try again.",
                  okbtn: "Ok",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                },
                disableClose: true,
              }
            );
          } else {
            this.apiservice.getServices(
              this.selectedBusiness.hashId,
              "0",
              this.page.toString()
            );
          }
        }
      }
    })
  }
  hideDiv:boolean = false
  ngOnInit(): void {
    // localStorage.removeItem(SM_CONSTANTS.CURRENT_ENTITY_HASH);
    this.loader = true
    this.loaderservice.showLoader = true
    this.apiservice.getBasicEntityList()
  }
  selectedBusiness:any
  selectBusiness(index:any){
    this.businessListData.forEach((element:any) => {
      element.isSelected = 0
    });
    this.businessListData[index].isSelected = 1
    this.selectedBusiness = this.businessListData[index]
    localStorage.setItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,this.selectedBusiness.entity_public_hash_id)
    sessionStorage.setItem('shop_service_status', this.selectedBusiness.shop_service_status)
    sessionStorage.setItem('home_service_status',this.selectedBusiness.home_service_status)
    sessionStorage.setItem('virtual_service_status',this.selectedBusiness.virtual_service_status)
    let countryList: any[] = COUNTRY_CODES;

    let selectedCurrency = {
      currency: this.selectedBusiness.currency,
      currencySymbol: this.selectedBusiness.currency_symbol,
      countryCode: this.selectedBusiness.entity_country_code,
      code: countryList.find(country => country.dial_code === this.selectedBusiness.entity_country_code && country.currency === this.selectedBusiness.currency)?.code
    };
    sessionStorage.setItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,JSON.stringify(selectedCurrency))
    let isEntityForeign = this.selectedBusiness.currency == 'INR' ? '0' : '1'

    localStorage.setItem(SM_CONSTANTS.IS_ENTITY_FOREIGN, isEntityForeign)
    this.page = 1
    this.hideDiv = true
    this.loaderservice.showLoader = true
    this.apiservice.getServices(this.selectedBusiness.hashId, '0', this.page.toString())
  }  
  createNewBusiness(){
    // this._modelRef.open(CreateNewBusinessComponent, {
    //   width: '500px',
    //   data: {
    //     title: 'Create Business',
    //     ref: this._modelRef
    //   },
    // });
    this.router.navigate(['purchased-plan']);
}

onCreateNewService(){
  let data = {
    title: 'Add service',
    type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
    ref: this._modelRef,
    entityHash: this.selectedBusiness.hash_id
  }
  let dialogref = this.dialogService.openFullScreenDialog(AddNewServiceForBusinessComponent, data);

dialogref.afterClosed().subscribe(res =>{
  if(res){
    this.apiservice.getServices(this.selectedBusiness.hashId, '0', this.page.toString())
  }
})
  }
    onCreateNewServiceFromTemplate(){
      let data = {
        title: 'Add service From Template',
        ref: this._modelRef,
        entityHash: this.selectedBusiness.hash_id
      }
      let dialogref = this.dialogService.openFullScreenDialog(AddNewTemplateServiceForBusinessComponent, data);
      dialogref.afterClosed().subscribe(res =>{
        if(res){
          this.apiservice.getServices(this.selectedBusiness.hashId, '0', this.page.toString())
        }
      })
    }

    onEdit(rowvalue:any){
      this.loaderservice.showLoader = true
      let data = {
        title: 'Edit service',
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
        data: rowvalue,
        entityHash: this.selectedBusiness.hash_id
      }
     let dialogref =  this.dialogService.openFullScreenDialog(AddNewServiceForBusinessComponent,data);
      dialogref.afterClosed().subscribe(res =>{
        if(res){
          this.apiservice.getServices(this.selectedBusiness.hashId, '0', this.page.toString())
        }
      })
    }

  deleteService(rowvalue:any){

    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
      // width: "400px",
      data : {
        title : 'Alert',
        message : 'Are you sure you want to delete this service?',
        okbtn : 'Confirm',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 

    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        isDelete: 1
      }
    }
    this.loaderservice.showLoader = true
    this.apiservice.addUpdateServiceType(metadata, this.selectedBusiness.hash_id)
      }
    })


    
    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }
  firstTimeBelow3:boolean = false;
  searchServiceData(){
    if(this.searchString.value.length >= 3){
      this.firstTimeBelow3 = true
      this.page = 1
      this.apiservice.getServiceDataByKeyword(this.selectedBusiness.hash_id, this.page.toString(), this.searchString.value)
    }
    else{
      if (this.firstTimeBelow3) {
      this.firstTimeBelow3 = false
      this.page = 1
      this.apiservice.getServices(this.selectedBusiness.hashId, '0', this.page.toString())
      }
    }
  }
  reset(){
    this.searchString.reset()
    this.page = 1
    this.apiservice.getServices(this.selectedBusiness.hashId, '0', this.page.toString())
  }
  onPageChange(ev: any) {
    this.loaderservice.showLoader = true
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    if(this.searchString.value && this.searchString.value != ''){
      this.apiservice.getServiceDataByKeyword(this.selectedBusiness.hash_id, this.page.toString(), this.searchString.value)
    }
    else{
      this.apiservice.getServices(this.selectedBusiness.hashId, '0', this.page.toString())
    }
   
  }
  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }


  openvideo(){
    this.dialog.open(YoutubeEmbedVideoComponent,{
    width:'1000px',
    disableClose:true,
    data:{
      link:"https://www.youtube.com/embed/zTudWBFIAtc",
      title: 'Adding Service, Creating Catalog in LookzUp Business Web Portal.'
    }})
    }

    opencontact(){
      this.router.navigate(['/contact-us']);
    }

    selectcountry(){
      let dialogref = this.dialog.open(SelectBusinessCountryComponent,{
      maxWidth:'500px',
    width:'500px',
      disableClose:true,
      data:{
        link:"",
        title: 'Select country',
        ref: this.dialog
      }})
      dialogref.afterClosed().subscribe(res => {
        if(res){
          this.router.navigate(['purchased-plan']);
        }
      } 
      )
      }

      changeStatus(item:any,status:any){
        this.loaderservice.showLoader = true
        let metadata = {
          "serviceTypeInfo": {
              "serviceName": item.serviceName,
              "approxTime": item.approxTime,
              "description": item.description,
              "shop_rate": item.shop_rate && item.shop_rate != '-' ? item.shop_rate : 0,
              "home_rate": item.home_rate && item.home_rate != '-' ? item.home_rate : 0,
              "virtualRate": item.virtual_rate && item.virtual_rate != '-' ? item.virtual_rate : 0,
              "virtual_rate": item.virtual_rate && item.virtual_rate != '-' ? item.virtual_rate : 0,
              "imgUrl": item.imgUrl,
              "thumbUrl": item.thumbUrl,
              "status": status,
              "homeStatus": item.homeStatus,
              "shopStatus": item.shopStatus,
              "virtualStatus": item.for_virtual,
              "for_virtual": item.for_virtual,
              "discountStatus": item.discountStatus,
              "discountAmount": item.discountAmount,
              "shopDiscountedPrice": item.shopDiscountedPrice && item.shopDiscountedPrice != '-' ? item.shopDiscountedPrice : 0,
              "homeDiscountedPrice": item.homeDiscountedPrice && item.homeDiscountedPrice != '-' ? item.homeDiscountedPrice : 0,
              "virtualDiscountedPrice": item.virtual_discounted_amount && item.virtual_discounted_amount != '-' ? item.virtual_discounted_amount : 0,
              "virtual_discounted_amount": item.virtual_discounted_amount && item.virtual_discounted_amount != '-' ? item.virtual_discounted_amount : 0,
              "tax_collecion_status": item.tax_collection_status,
              "rate": item.rate,
              "businessHashId": item.businessHashId,
              "hash_id": item.hash_id,
              "currency": item.currency,
              "currency_symbol": item.currency_symbol,
              "tax_collection_status": item.tax_collection_status,
                "tax_slab_hash": item.tax_slab_hash,
          "discountType": item.discountType,
          }
      }
          Object.keys(metadata.serviceTypeInfo).forEach(key => {
      if ((metadata.serviceTypeInfo as any)[key] === null) {
        delete (metadata.serviceTypeInfo as any)[key];
      }
    });
    
        this.apiservice.addUpdateServiceType(metadata, this.selectedBusiness.hash_id)
      }

      openLink(url: string): void {
        window.open(url, "_blank");
      }

}
